module.exports = __webpack_public_path__ + "img/9.e1b4ae7.jpg";